import { render, staticRenderFns } from "./LongTermOrder.vue?vue&type=template&id=2dcd4cfc&scoped=true&"
import script from "./LongTermOrder.vue?vue&type=script&lang=js&"
export * from "./LongTermOrder.vue?vue&type=script&lang=js&"
import style0 from "./LongTermOrder.vue?vue&type=style&index=0&id=2dcd4cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd4cfc",
  null
  
)

export default component.exports